export default __webpack_public_path__ + "static/media/Ekierka-05.1d7e880b.svg";